import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, filter, lastValueFrom } from 'rxjs';
import { Habit, HabitPagedResult } from 'src/app/api/habits-api/models';
import { HabitService } from 'src/app/api/habits-api/services';

@Injectable({
	providedIn: 'root'
})
export class HabitsHelperService {
	private habitService = inject(HabitService);

	private habits: BehaviorSubject<HabitPagedResult> =
		new BehaviorSubject<HabitPagedResult>(null);

	public habits$: Observable<HabitPagedResult> = this.habits.pipe(
		filter(
			(habits) =>
				habits != null && habits != undefined && habits.results != null
		)
	);

	public initialize(): void {
		this.habitService
			.getHabit$Json({
				page: 1,
				pageSize: 25
			})
			.subscribe((habits) => {
				this.habits.next(habits);
			});
	}

	public getPagedHabits(page: number, pageSize: number) {
		this.habitService
			.getHabit$Json({
				page: page,
				pageSize: pageSize
			})
			.subscribe((data) => {
				this.habits.next(data);
			});
	}

	public getHabitsForExport(pageSize: number) {
		return this.habitService.getHabit$Json({
			page: 1,
			pageSize: pageSize
		});
	}

	public getHabitById(id: string): Observable<Habit> {
		return this.habitService.getHabitId$Json({ id });
	}

	public async addHabit(habit: Habit): Promise<void> {
		habit.slug = habit.name.toLowerCase().replace(/\s+/g, '-');
		return await lastValueFrom(
			this.habitService.postHabit$Json({ body: habit })
		)
			.then(() => {
				this.refreshHabits();
			})
			.catch((error: unknown) => {
				console.error('Add Habit Error:', error);
				return Promise.resolve();
			});
	}

	public editHabit(habit: Habit): void {
		this.habitService
			.putHabitId({ id: habit.id, body: habit })
			.subscribe(() => {
				this.refreshHabits();
			});
	}

	public removeHabit(id: string): void {
		this.habitService.deleteHabitId({ id }).subscribe({
			next: () => {
				this.refreshHabits();
			},
			error: (error) => {
				console.error('Delete Habit Error:', error);
			}
		});
	}

	private refreshHabits(): void {
		this.habitService.getHabit$Json().subscribe((habits) => {
			this.habits.next(habits);
		});
	}
}
